function DescriptionListItem({ children }) {
  return (
    <div className="grid items-center grid-cols-2 py-4 border-b last:border-b-0">
      {children}
    </div>
  );
}

export { DescriptionListItem };
